import { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { connectSerialDeviceIntermediate } from '../../WebSerialConnection/SerialUSBConnect'

/**
 * useHeaderDevice
 * -------------------------------------------------
 * Shared device-connection engine for the header.
 * Owns the mismatch / connection-error state and the serial
 * connect / mismatch-resolution / recovery-erase handlers that were
 * previously duplicated across MainHeaderToki and Make/MainHeader.
 */
export default function useHeaderDevice({
    webSerial,
    worker,
    socketData,
    device,
    concept,
    deviceMismatch,
    deviceDetail,
    DeselectedComponent,
    webSerialConnect,
}) {
    const history = useHistory()
    const [isDeviceMismatch, setIsDeviceMismatch] = useState(false)
    const [showErrorMsg, setshowErrorMsg] = useState(false)

    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')

    let deviceName = ''
    switch (connectedDevice) {
        case 'Hexapod':
            deviceName = 'Crawl-e'
            break
        default:
            deviceName = 'Zing'
    }

    const requestConnection = async () => {
        if (webSerial.isConnected) return

        // Web Serial is Chromium-only and requires a secure context; on other
        // browsers `navigator.serial` is undefined and the call below would throw.
        if (!navigator?.serial) {
            setshowErrorMsg(true)
            return
        }

        try {
            let res = await connectSerialDeviceIntermediate(
                { isAutomatic: false },
                worker,
                socketData
            )
            if (res !== undefined) {
                if (!res.isPortOpen) {
                    deviceMismatch({
                        deviceMismatched: res.matchedObj_with_Version,
                        isMemoryPresent: res.isMemoryPresent,
                        isArmError: res.isArmError,
                        plodeNativeData: {
                            ...device.plodeNativeData,
                            mountPoint: res.mountPoint,
                        },
                    })
                    setIsDeviceMismatch(true)
                } else {
                    setIsDeviceMismatch(false)
                    deviceMismatch({
                        deviceMismatched: {},
                        isMemoryPresent: res.isMemoryPresent,
                        isArmError: res.isArmError,
                        plodeNativeData: {
                            ...device.plodeNativeData,
                            mountPoint: res.mountPoint,
                        },
                    })
                }
            }

            if (res) webSerialConnect({ port: res.port })
            else setshowErrorMsg(true)
        } catch (err) {
            // User dismissing the native port-chooser rejects with a NotFound
            // "No port selected by the user" DOMException — that's an expected
            // cancel, so stay quiet. Anything else is a real failure: surface it
            // instead of leaving the UI in a dead/"frozen" state.
            if (err?.name !== 'NotFoundError') {
                console.error('Device connection failed:', err)
                setshowErrorMsg(true)
            }
        }
    }

    // for mismatch of device while connecting
    const handleDevice = async (option) => {
        if (option === 'no') {
            let port = webSerial.port
            //is this needed??
            // await openSerialReadComPort(port,worker)
        } else {
            shouldErase()
            history.push('/Selection')
            let mismatchedDevice = device.deviceMismatched
            console.log(mismatchedDevice)
            sessionStorage.setItem('connectedDevice', mismatchedDevice.id)
            sessionStorage.setItem('deviceVersion', mismatchedDevice.version)
            if (webSerial.isConnected)
                sessionStorage.setItem('isDeviceConnected', true)
            deviceDetail({
                connectedDevice: mismatchedDevice.id,
                deviceVersion: mismatchedDevice.version,
            })
        }
        setIsDeviceMismatch(false)
        deviceMismatch({ deviceMismatched: {} })
    }

    // when device is disconnected, clear the mismatch state
    useEffect(() => {
        if (sessionStorage.getItem('isDeviceConnected') == 'false') {
            setIsDeviceMismatch(false)
            deviceMismatch({ deviceMismatched: {} })
        }
    }, [webSerial.isConnected])

    const shouldErase = () => {
        let programMode = sessionStorage.programMode
        let connectedDevice = sessionStorage.connectedDevice
        let version = sessionStorage.deviceVersion
        let recoveryData = JSON.parse(localStorage.getItem('recoveryData'))
        if (
            localStorage.getItem('recoveryData') !== null &&
            programMode in recoveryData &&
            connectedDevice in recoveryData[programMode] &&
            version in recoveryData[programMode][connectedDevice]
        ) {
            if (Object.keys(recoveryData).length === 1) {
                if (Object.keys(recoveryData[programMode]).length === 1) {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        localStorage.removeItem('recoveryData')
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                        localStorage.setItem(
                            'recoveryData',
                            JSON.stringify(recoveryData)
                        )
                    }
                } else {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode][connectedDevice]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                }
            } else {
                if (Object.keys(recoveryData[programMode]).length === 1) {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                } else {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode][connectedDevice]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                }
            }
        }
        sessionStorage.removeItem('programEnd')
        sessionStorage.setItem('pip', false)
        sessionStorage.setItem('name', 'null')
        sessionStorage.removeItem('Index')
        sessionStorage.setItem('shield', 'false')
        sessionStorage.setItem('peeCeeATR', 'false')
        sessionStorage.setItem('arm_shield', 'false')
        sessionStorage.removeItem('PET')
        sessionStorage.removeItem('EndSwitch')
        concept.Index = []
        DeselectedComponent({
            Four_in_one_sensor: {
                isDistanceSensors: false,
                isGestureSensor: false,
                isLightSensor: false,
                isColorSensor: false,
            },
            isFour_in_one_sensor: false,

            isMic: false,
            isTemperature: false,

            // input
            isTouchZero: false,
            isTouchOne: false,
            isTouchTwo: false,

            // output
            isTouchZeroOutput: false,
            isTouchOneOutput: false,
            isTouchTwoOutput: false,

            isLeftEye: false,
            isRightEye: false,
            isbuzzer: false,

            isSmileOne: false,
            isSmileTwo: false,
            isSmileThree: false,
            isSmileFour: false,
        })
    }

    // handle error in connection
    const handleError = async () => {
        setshowErrorMsg(false)
        window.location.reload()
    }

    useEffect(() => {
        if (device) {
            let deviceD = Object.keys(device.deviceMismatched)
            if (deviceD.length > 1) {
                if (isDeviceMismatch == false) {
                    setIsDeviceMismatch(true)
                }
            }
        }
    }, [device.deviceMismatched])

    return {
        history,
        connectedDevice,
        deviceVersion,
        deviceName,
        isDeviceMismatch,
        setIsDeviceMismatch,
        showErrorMsg,
        setshowErrorMsg,
        requestConnection,
        handleDevice,
        handleError,
    }
}
